import React from 'react';
import { motion } from 'framer-motion'

// Import company logos (example paths)
import MernixLogo from '../Images/Mernix Consulting.jpeg';
import SwadesiLogo from '../Images/Swadesi wear logo.jpeg';
import EmergingTalksLogo from '../Images/Emerging Talks.jpeg';
import RecroSolsLogo from '../Images/RecroSols.jpeg';
import COEPTULogo from '../Images/Coep.jpeg';

const Experience = () => {
  const experiences = [
    {
      company: "Mernix Consulting",
      logo: MernixLogo,
      role: "Full Stack Developer (July 2024).",
      description: "Developing and maintaining web applications using the MERN stack.",
      linkedin: "https://www.linkedin.com/in/mernix-consulting-411045319/"
    },
    {
      company: "Swadesi Wear",
      logo: SwadesiLogo,
      role: "Development Associate (June 2024).",
      description: "Developed the website using Shopify, managed products, and handled social media presence.",
      linkedin: "https://www.linkedin.com/company/swadesi-wear/"
    },
    {
      company: "Emerging Talks",
      logo: EmergingTalksLogo,
      role: "Business Associate (May 2024).",
      description: "Coordinated with clients and arranged business meetings with the co-founder.",
      linkedin: "https://www.linkedin.com/company/emerging-talks/"
    },
    {
      company: "RecroSols",
      logo: RecroSolsLogo,
      role: "Development Lead (June 2023 - May 2024).",
      description: "Developed new websites, managed clients' websites using WordPress, and edited photos on Canva.",
      linkedin: "https://www.linkedin.com/company/recrosols/"
    },
    {
      company: "COEP Technological University",
      logo: COEPTULogo,
      role: "Java Developer (January 2023 - June 2023).",
      description: "Developed Java code to generate random value questions and compiled them into an Excel sheet.",
      linkedin: "https://www.linkedin.com/school/coep-technological-university/"
    }
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 md:px-8 lg:px-16" id="work">
      <h1 className="text-2xl md:text-4xl font-bold mb-8">Work Experience</h1>
      <div className="max-w-6xl w-full grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 justify-items-center">
        {experiences.map((experience, index) => (
          <a
            key={index}
            href={experience.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="text-black"
          >
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-gray-100 p-6 rounded-lg shadow-lg flex flex-col items-center cursor-pointer"
            >
              <img src={experience.logo} alt={`${experience.company} Logo`} className="h-20 w-20 object-contain mb-4" />
              <h2 className="text-lg md:text-xl font-semibold">{experience.company}</h2>
              <p className="text-gray-700 text-center">{experience.role}</p>
              <p className="text-gray-700 text-center">{experience.description}</p>
            </motion.div>
          </a>
        ))}
      </div>
    </div>
  );
  
};

export default Experience;
